import { TezosToolkit } from "@taquito/taquito";

const Tezos = new TezosToolkit("https://mainnet-tezos.giganode.io"); // Replace with your Tezos RPC

export const useTezos = () => {
  const getUserNFTs = async (userAddress) => {
    try {
      // Fetch NFTs owned by the user from a Tezos indexer
      const response = await fetch(
        `https://api.tezos-nft.com/nfts?owner=${userAddress}`
      );
      const data = await response.json();
      return data.nfts || [];
    } catch (error) {
      console.error("Error fetching NFTs:", error);
      return [];
    }
  };

  const createAuction = async (nft_id, start_bid, duration) => {
    try {
      const contract = await Tezos.wallet.at("KT1YourAuctionContractAddress"); // Replace with actual contract address
      const operation = await contract.methods
        .createAuction(nft_id, start_bid, duration)
        .send();
      await operation.confirmation();
      return { success: true, auction_id: operation.opHash };
    } catch (error) {
      console.error("Error creating auction on Tezos:", error);
      return { success: false };
    }
  };

  return { getUserNFTs, createAuction };
};
